<template>
  <div v-if="organizers && organizers.length > 0">
    <div v-if="showHeader" class="mb-2 medium-18">Organizers :</div>
    <div v-for="(org, index) in organizers" :key="index">
      <span v-if="org.lead" class="px-2 badge badge-pill bg-secondary typo-color-white">
        LEAD
      </span>
      <router-link :to="{ name: 'people', params: { id: org.person_id }, query: { reDirectFrom: 'link' }}">
        <span class="typo-color-blue regular-16">{{ org.name }}</span><span class="typo-color-black">,</span>
      </router-link>

      <span v-if="org.institution !==null && (org.institution.name !== undefined && org.institution.name !== null)">
        {{ org.institution.name }}
      </span>
      <span v-else>
        {{ org.institution }}
      </span>
      <!-- <span v-if="index < organizers.length - 1">, </span> -->
    </div>
    <div class="bold-16 typo-color-blue mt-3 pb-3" v-if="canEditCms && organizersEmailIds !== '' && organizersEmailIds !== null && organizersEmailIds !== undefined">
      <i class="fas fa-envelope"></i>
      <a :href="`mailto:${organizersEmailIds}`">Email All</a>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'OrganizerSection',
  props: ['organizers', 'organizersEmailIds', 'showHeader'],
  computed: {
    ...mapGetters(['canEditCms'])
  },
}
</script>
